export default "__VITE_ASSET__ClD_deL5__"